import type { FluentCartModalContext } from './fluentcart-modal-context';

function parseNullableInteger(value: string | null): number | null {
  if (value === null || value.trim() === '') {
    return null;
  }

  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
}

// return-status pages intentionally do not auto-open the FluentCart modal

export function parseFluentCartUrlParams(url: string): Partial<FluentCartModalContext> | null {
  let parsedUrl: URL;

  try {
    parsedUrl = new URL(url);
  } catch {
    return null;
  }

  const charityId = parseNullableInteger(parsedUrl.searchParams.get('charity_id'));
  if (charityId === null) {
    return null;
  }

  const periodId = parseNullableInteger(parsedUrl.searchParams.get('period_id'));
  const intentToken = parsedUrl.searchParams.get('intent_token');
  const action = parsedUrl.searchParams.get('action');
  const entry = parsedUrl.searchParams.get('entry');
  const isVoteIntent = action === 'vote'
    || action === 'vote_intent'
    || entry === 'complete_vote'
    || (intentToken !== null && intentToken.trim() !== '');

  return {
    charityId,
    charityName: '',
    periodId,
    intentToken: intentToken && intentToken.trim() !== '' ? intentToken : null,
    beneficiary: null,
    donateHrefFallback: '',
    bonusRatio: null,
    bonusCap: null,
    mode: isVoteIntent ? 'vote_plus_donate' : 'donate_only',
    entry: entry && entry.trim() !== '' ? entry.trim() : 'standard',
  };
}

export function cleanFluentCartUrlParams(cleanUrl: URL): void {
  cleanUrl.searchParams.delete('charity_id');
  cleanUrl.searchParams.delete('period_id');
  cleanUrl.searchParams.delete('intent_token');
  cleanUrl.searchParams.delete('action');
  cleanUrl.searchParams.delete('entry');
}
